/* tslint:disable */
/* eslint-disable */
/**
 * Muscula App API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  ExplanationRequest,
  ExplanationResponseGenericApiResponse,
} from '../models';
import {
    ExplanationRequestFromJSON,
    ExplanationRequestToJSON,
    ExplanationResponseGenericApiResponseFromJSON,
    ExplanationResponseGenericApiResponseToJSON,
} from '../models';

export interface ApiExplanationListPostRequest {
    explanationRequest?: ExplanationRequest;
}

/**
 * 
 */
export class ExplanationApi extends runtime.BaseAPI {

    /**
     */
    async apiExplanationListPostRaw(requestParameters: ApiExplanationListPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ExplanationResponseGenericApiResponse>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/Explanation/list`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ExplanationRequestToJSON(requestParameters.explanationRequest),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ExplanationResponseGenericApiResponseFromJSON(jsonValue));
    }

    /**
     */
    async apiExplanationListPost(requestParameters: ApiExplanationListPostRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ExplanationResponseGenericApiResponse> {
        const response = await this.apiExplanationListPostRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
